<!--suppress TypeScriptUnresolvedVariable -->
<div class="community-planning-data-container" *appVar="plannedCommunity|async as plannedCommunity">
    <div>
        <ng-container
                *ngTemplateOutlet="sharedEnergyData; context: {data: plannedCommunity.sharedEnergyData}">
        </ng-container>
    </div>
    <div>
        <ng-container
                *ngTemplateOutlet="planningData; context: {plannedQuantities: plannedCommunity.quantities}">
        </ng-container>
    </div>
</div>


<ng-template #planningData let-plannedQuantities="plannedQuantities">
    <div *ngIf="plannedQuantities" fxLayout="column" class="planned-quantities">
        <div *ngIf="!plannedQuantities.length" fxLayout="row" fxLayoutAlign="center">
            {{'Nothing planned'|i18n}}
        </div>
        <div *ngFor="let pq of plannedQuantities" class="measure-box mt-24"
             fxLayout="column" fxLayoutAlign="start stretch">
            <div fxLayout="row" fxLayoutAlign="start" class="planned-quantity-name ml-24">
                <div class="txt-h-18-7">
                    <app-icon [name]="pq.icon"></app-icon> &nbsp;{{pq.name}}</div>
            </div>
            <div *ngIf="pq.data.length" class="planned-quantity mb-24">
                <app-line-chart *ngIf="pq.data.length"
                                [data]="[{data: pq.data, style: {color: pq.color, strokeWidth: 1.5}}]"
                                [margins]="{left:75, right: -20}"
                                [yTickFormatter]="pq.uom|yTickFormatter"
                                [tooltipFormatter]="pq.uom|tooltipFormatter:TIME_DELTA_QUARTER_HOUR"
                                [xGrid]="true"
                                [yGrid]="true"
                                [gridColor]="gridColor"
                                [tooltipBorderColor]="tooltipBorderColor"
                                [tooltipBackgroundColor]="tooltipBackgroundColor"
                                [selectionLineColor]="selectionLineColor"
                                [xTickSpace]="80"
                                [yTickSpace]="30"
                                [resizeTrigger]="contentResize">
                </app-line-chart>
            </div>
            <div *ngIf="!pq.data.length" fxLayout="row" fxLayoutAlign="center" class="mt-24">
                <app-icon name="fal-exclamation-circle"></app-icon>&nbsp;
                <span class="pl-8">{{'No data planned'|i18n}}</span>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #sharedEnergyData let-data="data">
    <div *ngIf="data" fxLayout="column" class="planned-quantities measure-box mt-24">
        <div *ngIf="!data.length" fxLayout="row" fxLayoutAlign="center">
            {{'No data'|i18n}}
        </div>
        <div fxLayout="column" fxLayoutAlign="start stretch">
            <div fxLayout="row" fxLayoutAlign="start" class="planned-quantity-name ml-24">
                <div class="txt-h-18-7">
                    <app-icon name="fal-users"></app-icon>&nbsp;{{'Shared energy'|i18n}}</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="1rem" class="mt-8">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.25rem">
                    <span [style]="{'background-color': injectedColor}" class="legend-dot"></span>
                    <span>{{'Injected energy'|i18n}}</span>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.25rem">
                    <span [style]="{'background-color': absorbedColor}" class="legend-dot"></span>
                    <span>{{'Absorbed energy'|i18n}}</span>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0.25rem">
                    <span [style]="{'background-color': sharedColor}" class="legend-dot"></span>
                    <span>{{'Shared energy'|i18n}}</span>
                </div>
            </div>
            <div class="shared-energy">
                <app-shared-energy-chart [data]="data"
                                         [padding]="0.25"
                                         [margins]="{left:75, right: -20, top: 10, bottom: 30}"
                                         [xTickSpace]="80"
                                         [yTickSpace]="30"
                                         [yTickFormatter]="'kWh'|yTickFormatter"
                                         [tooltipFormatter]="'kWh'|sharedEnergyTooltipFormatter:false:TIME_DELTA_HOUR"
                                         [xGrid]="true"
                                         [yGrid]="true"
                                         [gridColor]="gridColor"
                                         [tooltipBorderColor]="tooltipBorderColor"
                                         [tooltipBackgroundColor]="tooltipBackgroundColor"
                                         [selectionLineColor]="selectionLineColor"
                                         [resizeTrigger]="contentResize"
                                         [injectionColor]="injectedColor"
                                         [absorptionColor]="absorbedColor"
                                         [sharedColor]="sharedColor">
                </app-shared-energy-chart>
            </div>
        </div>
    </div>
</ng-template>
